import clsx from 'clsx';

import * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import { useHiveClient } from '@gitbook/hive-react';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    Dialog,
    DialogBody,
    DialogCloseButton,
    DialogFooter,
    DialogHeader,
    Heading,
    useDialogClose,
} from '@gitbook/spine-react';

import {
    AgentChatInput,
    encodeDocumentForAPI,
    useBasicEditorPersistedValue,
    useCreateAgent,
} from '../../../Components';
import { useNavigation } from '../../../navigation';
import { apiClient } from '../../../state';

/**
 * Dialog to create a new change request with the AI agent
 */
export function NewAgentChangeRequestDialog(props: { space: api.Space }) {
    const { space } = props;

    const { value, setValue } = useBasicEditorPersistedValue('newBrainstormMessage');
    const closeDialog = useDialogClose();
    const { navigate } = useNavigation();

    const hiveClient = useHiveClient();
    const createAgent = useCreateAgent();

    const onSubmit = async () => {
        const { data: changeRequest } = await apiClient.changeRequests.createChangeRequest(
            space.id,
            {
                subject: '',

                // TODO: pass the task for the agent
            }
        );

        const agent = createAgent({
            pathname: `/agents/o/${space.organization}/s/${space.id}/c/${changeRequest.id}`,
            getToken: async () => hiveClient.auth.getToken(space.id),
        });
        agent.postMessage({
            role: api.AIMessageRole.User,
            content: encodeDocumentForAPI(value.document),
        });

        analytics.logEvent(
            analytics.createChangeRequestEvent(space, changeRequest.id, {
                type: 'change_request_create',
                mode: 'agent',
            })
        );

        closeDialog();
        navigate({
            screen: {
                type: 'space',
                space: space.id,
                changeRequest: changeRequest.number,
                sideSheet: {
                    type: 'agent',
                },
            },
        });
    };

    return (
        <Dialog>
            <DialogHeader>
                <Heading>Describe the task</Heading>
                <Description>
                    Describe the task of the change request, and brainstorm with Docs Agent to craft
                    a plan of actions.
                </Description>
            </DialogHeader>
            <DialogBody>
                <AgentChatInput
                    value={value}
                    setValue={setValue}
                    placeholder="What do you want to do?"
                    className={clsx(
                        'rounded border',
                        value.isFocused ? 'border-primary' : 'border-base'
                    )}
                />
            </DialogBody>
            <DialogFooter>
                <DialogCloseButton />
                <Button
                    kind="primary"
                    label="Start task in a change request"
                    leadingIcon={Icon.ChangeRequestNew}
                    onPress={async () => {
                        await onSubmit();
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
}
